import React from 'react';
import PropTypes from 'prop-types';
import * as homeActions from '../actions/homeActions';

import * as pricingActions from '../actions/pricingActions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { reduxForm, initialize } from 'redux-form';
import ReactGA from 'react-ga';
import { getDateString } from '../utils/dates';


import DatePicker from 'react-datepicker';



import getPortalLocData from '../config/loc';

import '../styles/preBookingCard.scss';


class PreBookingCard extends React.Component{
    
    constructor(props){
        let now = new Date();
            now.setMinutes(0);
            now.setSeconds(0);
            now.setMilliseconds(0);

        let fourHoursLater = new Date(now.getTime() + 4 * 60 * 60 * 1000);
        let fourYearsLater = new Date();
            fourYearsLater.setFullYear(fourYearsLater.getFullYear() + 4);
        let defaultStart = new Date(fourHoursLater.getFullYear(), fourHoursLater.getMonth(), fourHoursLater.getDate(), fourHoursLater.getHours(), 0, 0, 0);
        let defaultEnd = new Date(defaultStart.getTime() + 24 * 60 * 60 * 1000);


        super(props);
        this.state = {
            startDateTime: defaultStart,
            endDateTime: defaultEnd,
            fourHoursLater: fourHoursLater,
            fourYearsLater: fourYearsLater,
            duration: Math.floor((defaultEnd.getTime() - defaultStart.getTime()) / (1000 * 60 * 60)),
            ready: false,
            isSpaceAvailable: false,
            cookiesAccepted: false,
            availabilityData: {},
        };

        this.handlerFromTimeChange(defaultStart);
        this.handlerToTimeChange(defaultEnd);

        this.handleStart = this.handleStart.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
    }

    componentDidMount(){
        this.handlerPriceInitial();
        this.setState({ready: true});
        this.fetchThreeMonthsAvailability();
        window.addEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: true });
        });
    }

    componentWillUnmount() {
        window.removeEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: false });
        });}
    
    handlerFromTimeChange(time){
        this.props.homeActions.updateBookingFromDate(time.toISOString()).then(()=>{
            this.handlerPriceChange();
        });
    }
    handlerToTimeChange(time, handlerPriceChange){
        this.props.homeActions.updateBookingToDate(time).then(()=>{
            if (handlerPriceChange) {
                this.handlerPriceChange();
            }
        });
    }

    handleStart(event) {
        let t = event;
            t.setMinutes(0);
            t.setSeconds(0);
            t.setMilliseconds(0);

        let hours = Math.floor((this.state.endDateTime.getTime() - t.getTime()) / (1000 * 60 * 60));
        let end = (hours < 24 ? new Date(t.getTime() + 24 * 60 * 60 * 1000) : this.state.endDateTime);
    
        this.setState({
            startDateTime: t,
            endDateTime: end,
            duration: Math.floor((end.getTime() - t.getTime()) / (1000 * 60 * 60)),
        });
    
        this.handlerFromTimeChange(t);
        this.handlerToTimeChange(end, false);
    }

    handleEnd(event) {
        let t = event;
            t.setMinutes(0);
            t.setSeconds(0);
            t.setMilliseconds(0);

        this.setState({
            endDateTime: t,
            duration: Math.floor((t.getTime() - this.state.startDateTime.getTime()) / (1000 * 60 * 60))
        });

        this.handlerToTimeChange(t.toISOString(), true);
    }

    handlerPriceChange(){
        this.getPrice();
    }

    getPrice () {
        if (!this.state.ready) {
            return; }

        let { locationId, durationUnits} = this.props;
        let request = {
          locationId:locationId,
          startTime:this.state.startDateTime,
          duration:this.state.duration,
          durationUnit:durationUnits,
          smsReminder:false,
          tariffGroupId: getPortalLocData().tarrifID,
          optionalServices:[]
        };


        this.props.pricingActions.getPrice(request);
        this.props.homeActions.checkSpaceAvailable(
            getDateString(this.state.startDateTime), 
            getDateString(this.state.endDateTime),
            locationId
        ).then((result) => {
            this.setState({isSpaceAvailable: result.spaceAvailable});
        });
    }

    handlerPriceInitial() {
        let start = new Date(this.props.startDate);
        let end = new Date(this.props.untilDate);
    
        let initialDuration;
        if (this.props.startDate) {
            initialDuration = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60)); // Calculate duration in hours
            this.setState({
                duration: initialDuration,
                startDateTime: start,
                endDateTime: end,
            });
        }
    
        this.getPrice();
    }

    fetchThreeMonthsAvailability() {
        console.log('~ - - - - - - - - - - - - - ');
        console.log('~ this.state.availabilityData, ', this.state.availabilityData);
        if (Object.keys(this.state.availabilityData).length > 0) {
            return;
        }
        
        const now = new Date();
        const threeMonthsLater = new Date();
        threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
        
        // Round to start of day
        now.setHours(0, 0, 0, 0);
        threeMonthsLater.setHours(0, 0, 0, 0);

        const availabilityData = {};
        let currentDate = new Date(now);

        const checkAvailability = () => {
            if (currentDate > threeMonthsLater) {
                this.setState({ availabilityData });
                return;
            }

            const nextDate = new Date(currentDate);
            nextDate.setDate(nextDate.getDate() + 1);
            
            this.props.homeActions.checkSpaceAvailable(
                getDateString(currentDate),
                getDateString(nextDate),
                this.props.locationId
            )
            .then(result => {
                availabilityData[currentDate.toISOString().split('T')[0]] = result.spaceAvailable;
                currentDate.setDate(currentDate.getDate() + 1);
                checkAvailability();
            })
            .catch(error => {
                console.error('Error fetching availability:', error);
                currentDate.setDate(currentDate.getDate() + 1);
                checkAvailability();
            });
        };

        checkAvailability();
    }
    
    render(){
        const { 
            handleSubmit, 
            isLoading,
            startDate,
            minimumDuration,
            tariffGroupId,
            maximumDuration,
            durationUnits,
            isNarrow
        } = this.props;
        
        const {
            startDateTime,
            endDateTime,
            fourHoursLater,
            fourYearsLater,
            isSpaceAvailable,
            duration
        } = this.state;

        let { defaultPricingModel } = this.props.pricingDetail;

        return (
            <div className={(!isNarrow ? "search_bus_area home_search_bus_area" : "")}>
                <div className="row homeDatePanel g-3 pt-3 pr-3 pl-3 pb-2">
                    <div className={"dateTime " + (isNarrow ? "col-sm-12" : "col-lg-4 col-md-5 col-sm-6 offset-lg-1")}>
                        <div className="dateTime__label ">
                            Enter
                        </div>
                        <div className="row">
                            <div className="col-8 pr-0">
                                <DatePicker 
                                    selected={startDateTime} 
                                    onChange={this.handleStart} 
                                    value={startDateTime} 
                                    disableClock={true}
                                    minDate={fourHoursLater}
                                    calendarIcon={null}
                                    minDetail={'year'}
                                    selectsStart
                                    clearIcon={null}
                                    filterDate={(date) => {
                                        return this.state.availabilityData[date.toISOString().split('T')[0]];
                                    }}
                                    
                                    dateFormat="dd / MMM / yyyy"
                                    className="form-control form-select__date"
                                    startDate={startDateTime}
                                    endDate={endDateTime}
                                    maxDate={fourYearsLater}
                                    />
                            </div>
                            <div className="dateTime__select col-4 pl-0 form-select__time">
                            <select className="form-select" 
                                value={startDateTime.getHours()} 
                                id="startDateTime"
                                onChange={(e) => {
                                    const selectedHour = parseInt(e.target.value, 10);
                                    this.handleStart(new Date(startDateTime.setHours(selectedHour)));
                                }}
                            >
                                {Array.from(Array(24).keys()).map((i) => {
                                    const hour12 = i % 12 === 0 ? 12 : i % 12;
                                    const ampm = i < 12 ? 'am' : 'pm';
                                    return <option key={i} value={i}>{`${hour12}:00 ${ampm}`}</option>;
                                })}
                            </select>

                            </div>
                            <div className="col-12">
                            <div className={"mt-2 alert alert-warning " + (startDateTime < new Date(new Date().getTime() - 60 * 60 * 1000) ? "d-block" : "d-none")}>
                                    Start time can't be in the past.
                                </div>
                                <div className={"mt-2 alert alert-warning " + (isSpaceAvailable ? "d-none" : "d-block")}>
                                    Sorry. Space is not available at this time.
                                </div>
                                
                            </div>
                        </div>

                    </div>

                    <div className={"dateTime " + (isNarrow ? "col-sm-12" : "col-lg-4 col-md-5 col-sm-6")}>
                        <div className="dateTime__label ">
                            Exit
                        </div>
                        <div className="row">
                            <div className="col-8 pr-0">
                                <DatePicker 
                                    onChange={this.handleEnd} 
                                    dateFormat="dd / MMM / yyyy"
                                    className="form-control form-select__date"
                                    selected={endDateTime}
                                    value={endDateTime} 
                                    disableClock={true}
                                    minDate={fourHoursLater}
                                    startDate={startDateTime}
                                    endDate={endDateTime}
                                    calendarIcon={null}
                                    selectsEnd
                                    minDetail={'year'}
                                    clearIcon={null}
                                    maxDate={fourYearsLater}
                                    filterDate={(date) => {
                                        return this.state.availabilityData[date.toISOString().split('T')[0]];
                                    }}
                                    />

                                </div>
                                <div className="dateTime__select col-4 pl-0 form-select__time">
                                    <select className="form-select" 
                                        value={endDateTime.getHours()} 
                                        id="endDateTime"
                                        onChange={(e) => {
                                            const selectedHour = parseInt(e.target.value, 10);
                                            this.handleEnd(new Date(endDateTime.setHours(selectedHour)));
                                        }}
                                    >
                                        {Array.from(Array(24).keys()).map((i) => {
                                            const hour12 = i % 12 === 0 ? 12 : i % 12;
                                            const ampm = i < 12 ? 'am' : 'pm';
                                            return <option key={i} value={i}>{`${hour12}:00 ${ampm}`}</option>;
                                        })}
                                    </select>
                                </div>
                        </div>
                    </div>


                    <form onSubmit={handleSubmit} className={"d-flex align-items-start " + (isNarrow ? "mt-3 col-sm-6 offset-sm-6" : "col-lg-2 col-md-2 col-sm-4 offset-8 offset-md-0")} style={{paddingTop: '2.4em'}}>
                        <button className={"btn btn-primary w-100 btn_loader px-0 " + (isLoading ? "loading" : "")} 
                            type="submit" 
                            disabled={
                                isLoading  || 
                                defaultPricingModel.alertText || 
                                this.state.duration < 1 || 
                                startDateTime < new Date() || 
                                !isSpaceAvailable}>
                            { startDate ? 'Update' : 'Book now'}
                        </button>
                    </form>
                </div>
            </div>
          );
      }
    


}

// Since this component is simple and static, there's no parent container for it.

PreBookingCard.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleFromTimeChange:PropTypes.func,
    handleToTimeChange:PropTypes.func,
    isLoading: PropTypes.bool.isRequired,

    startDateTime: PropTypes.object,
    endDateTime: PropTypes.object,
    duration: PropTypes.string,

    startDate:PropTypes.string,
    untilDate:PropTypes.string,

    untilTime: PropTypes.string,
    pricingActions:PropTypes.object,
    locationId:PropTypes.string.isRequired,
    minimumDuration:PropTypes.number.isRequired,
    maximumDuration:PropTypes.number.isRequired,
    durationUnits:PropTypes.number.isRequired,
    pricingDetail:PropTypes.object,
    offeringId:PropTypes.string,
    homeActions:PropTypes.object
};


function mapStateToProps(state) {
    return {
    pricingDetail: state.pricing,
      locationDetail:state.locationDetail
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
        pricingActions: bindActionCreators(pricingActions, dispatch),
        homeActions: bindActionCreators(homeActions, dispatch)
    };
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(reduxForm({
    form: 'prebooking',
    onSubmitSuccess: (result, dispatch, props) => {
        dispatch(initialize(props.form, props.values));
        if (this.state.cookiesAccepted) {
            ReactGA.event({
                category: 'default booking',
                action: 'defaule booking detail'
            });
        }
    }
})(PreBookingCard));


// WEBPACK FOOTER //
// ./src/components/PreBookingCard.jsx